import React from 'react';

import ButtonRefresh from './ButtonRefresh';
import MenuNewPlaylist from './MenuNewPlaylist';
import IconNew from '../svg/IconNew';

//V2
function NewPlaylistMenu() {
  return (
    <div className={`menu-left-container`} >
      <div id={`ref-rp`} className={`flexRow align top-menu-container`}  >
        <MenuNewPlaylist defaultClassColor={`type-light`}>
          <IconNew size={24} color={'#8C8C8C'} className={`icon-new-playlist`} />
          <span className={`type-regular fz14 label-new-playlist`}>Create playlist</span>
        </MenuNewPlaylist>
        <ButtonRefresh />
      </div>
    </div>
  )
}

export default NewPlaylistMenu;
